<template>
	<div class="modul">
		<el-tabs tab-position="left" stretch @tab-click="tabClick" v-model="tabsIndex" class="tabs-height">
			<el-tab-pane label="详情" name="1"><xiangqing ref="xiangqing" @updateIndex="updateIndex"></xiangqing></el-tab-pane>
			<el-tab-pane label="设备配置" name="2"><shebeipeizhi ref="shebeipeizhi" @updateIndex="updateIndex"></shebeipeizhi></el-tab-pane>
			<el-tab-pane label="照片" name="3"><zhaopian ref="zhaopian" @updateIndex="updateIndex"></zhaopian></el-tab-pane>
			<el-tab-pane label="设计档案" name="4"><shejidangan ref="shejidangan" @updateIndex="updateIndex"></shejidangan></el-tab-pane>
			<el-tab-pane label="检测档案" name="5"><jiancedangan ref="jiancedangan" @updateIndex="updateIndex"></jiancedangan></el-tab-pane>
			<el-tab-pane label="巡检档案" name="6"><xunjiandangan ref="xunjiandangan" @updateIndex="updateIndex"></xunjiandangan></el-tab-pane>
			<el-tab-pane label="健康状态" name="7"><jiankangzhuangtai ref="jiankangzhuangtai" @updateIndex="updateIndex"></jiankangzhuangtai></el-tab-pane>
			<el-tab-pane label="一桥一档" name="8"><yiqiaoyidang ref="yiqiaoyidang" @updateIndex="updateIndex" @addVisible="addVisible"></yiqiaoyidang></el-tab-pane>
			<el-tab-pane label="视频监控" name="9"><monitor ref="monitor" @updateIndex="updateIndex" @addVisible="addVisible"></monitor></el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import xiangqing from './xiangqing.vue';
import shebeipeizhi from './shebeipeizhi.vue';
import shejidangan from './shejidangan.vue';
import xunjiandangan from './xunjiandangan.vue';
import jiancedangan from './jiancedangan.vue';
import zhaopian from './zhaopian.vue';
import jiankangzhuangtai from './jiankangzhuangtai.vue';
import yiqiaoyidang from './yiqiaoyidang.vue';
import monitor from './monitor.vue';
export default {
	name: 'qiaoliangAdd',
	components: {
		xiangqing,
		shebeipeizhi,
		shejidangan,
		xunjiandangan,
		jiancedangan,
		zhaopian,
		jiankangzhuangtai,
		yiqiaoyidang,
		monitor
	},
	data() {
		return {
			tabsIndex: '1'
		};
	},
	mounted() {},
	methods: {
		tabClick(e) {
			this.tabsIndex = e.name;
		},
		updateIndex(index) {
			this.tabsIndex = index;
		},
		addVisible() {
			this.$emit('closeDialog');
		}
	}
};
</script>

<style lang="scss" scoped>
.tabs-height {
	height: 700px;
}

::v-deep .el-tabs--right {
	overflow: auto;
}
</style>
